import { render, staticRenderFns } from "./demoUserSingleSelectTable.vue?vue&type=template&id=1c387d06&"
import script from "./demoUserSingleSelectTable.vue?vue&type=script&lang=js&"
export * from "./demoUserSingleSelectTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports